import {
  addressesRegistry,
  type ChainAddresses,
  type ChainId as MorphoChainId
} from '@morpho-org/blue-sdk'
import type { ChainId } from '@repo/web3'

type LiquidationMorphoAddresses = Pick<ChainAddresses, 'morpho' | 'adaptiveCurveIrm'>

export function getMorphoAddresses(chainId: ChainId): LiquidationMorphoAddresses {
  const registry = addressesRegistry[chainId as number as MorphoChainId]
  if (!registry) throw new Error(`No addresses registry found for chainId: ${chainId}`)

  return registry
}
